module.exports = __webpack_public_path__ + "static/travel-tips-add-overlay-633a0bd5f284d99b8d73cd2fd882827d.png";